<template>
  <v-container>
    <p class="sub-hero-text">coming soon ...</p>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>